import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import classes from "./style.module.scss";
import SystemOverview from './components/SystemOverview';
import RecentActivity from './components/RecentActivity';
import ProductsOverview from './components/ProductsOverview';
import SlotsBooked from './components/SlotsBooked';
import Exported from '../../service/endpoints';
import request from '../../service';
import { localTimezone } from '../../helpers';
import { useNavigate } from 'react-router-dom';
import GetUserPermission from '../../component/GetUserPermission';

const AdminDashboard = () => {
  const [dashboardCount, setDashboardCount] = useState({})
  const [recentActivity, setRecentActivity] = useState([])
  const [meetingSlot, setMeetingSlot] = useState([])
  const navigate = useNavigate()
  const addReportPermission = GetUserPermission({ key: 'add', microAppPath: 'report' });
  const addAdminPermission = GetUserPermission({ key: 'add', microAppPath: 'manageAdmins' });
  const addNotifyPermission = GetUserPermission({ key: 'add', microAppPath: 'notification' });

  useEffect(() => {
    getDashboardSlot()
  }, [])

  const getMaskedTimeZone = (timeZone) => {
    return timeZone == 'Asia/Calcutta' ? 'Asia/Kolkata' : timeZone
  }

  const getDashboardSlot = () => {
    let url = `${Exported.Endpoints.dashboardSlots}`
    request({
      url: url,
      params: {
        timeZone: getMaskedTimeZone(localTimezone) || 'Asia/Dubai | Asia/Kolkata | Asia/Riyadh'
      }
    }).then((res) => {
      if (res?.data?.status) {
        setMeetingSlot(res?.data?.data?.meetSlots)
        const response = res?.data?.data
        let countObj = {
          user: res?.data?.data?.userCount,
          verifiedRetailerAndMechanicThisMonth: res?.data?.data?.verifiedRetailerAndMechanicThisMonth,
          qr: res?.data?.data?.activeQrCodes,
          feedback: res?.data?.data?.pendingFeedbacks,
          openRedeemRewards: res?.data?.data?.openRedeemRewards,
          retailerIncompleteAndPendingVerification: res?.data?.data?.retailerIncompleteAndPendingVerification,
          mechanicIncompleteAndPendingVerification: res?.data?.data?.mechanicIncompleteAndPendingVerification,
          openEnquiries: res?.data?.data?.openEnquiries,
          openContactForms: res?.data?.data?.openContactForms,
          retailerVerifiedWithoutTarget: res?.data?.data?.retailerVerifiedWithoutTarget,
          totalVerifiedRetailer : res?.data?.data?.totalVerifiedRetailer,
          totalVerifiedMechanic : res?.data?.data?.totalVerifiedMechanic
        }
        setDashboardCount(countObj)
        setRecentActivity(response)
      } else {
        setMeetingSlot([])
        setDashboardCount(null)
      }
    }).catch((err) => {
      console.log(err, "err")
    })
  }

  const redirectToAdmin = () => {
    navigate('/admin/manageAdmins?type=create')
  }

  const redirectToNotification = () => {
    navigate('/admin/notification')
  }


  return (
    <div className={`${classes.dashboardWrapper}`}>
      <div className={`w-[100%] flex items-center justify-between`}>
        <div className={`layout-title`}>Dashboard</div>
        <div>
          {addNotifyPermission &&
            <Button text={"Manage Notifications"} className={`mr-3`} smallBtn onClick={() => redirectToNotification()} />
          }
          {/* {addReportPermission &&
            <Button text={"Generate Report"} className={`mr-3`} smallBtn />
          } */}
          {addAdminPermission &&
            <Button text={"Create New Admin"} className={``} smallBtn onClick={() => redirectToAdmin()} />
          }
        </div>
      </div>
      <div>
        <SystemOverview dashboardCount={dashboardCount} />
        <RecentActivity contactResolved={recentActivity?.contactFormResolvedToday} enquiryResolved={recentActivity?.productEnquiryResolvedToday} feedbackResolved={recentActivity?.productFeedbackResolvedToday} />
        {/* <ProductsOverview /> */}
        <SlotsBooked meetingSlot={meetingSlot} />
      </div>
    </div>
  )
}

export default AdminDashboard